<h2 mat-dialog-title class="date-filter-title">
  {{ 'FRONTEND.DATE_RANGE_SELECTOR.TITLE' | translate }}
  <mat-icon inline class="close" (click)="dialogRef.close()">close</mat-icon>
</h2>

<ng-container *ngIf="comparableDatePicker$ | async; else normalDatePicker">
  <mat-dialog-content class="compare-date-range-group">
    <mat-form-field class="compare-date-range-group-cell picker-start">
      <input
        matInput
        [matDatepicker]="start"
        placeholder="{{
          'FRONTEND.DATE_RANGE_SELECTOR.DATE_PICKER.START_DATE' | translate
        }}"
        (dateChange)="onCustomStartChange(null, $event.value)"
        [defaultValue]="compareDateRange.start | date: 'mediumDate'"
        [max]="compareDateRange.end"
      />
      <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
      <mat-datepicker #start></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <input
        [matDatepicker]="end"
        matInput
        placeholder="{{
          'FRONTEND.DATE_RANGE_SELECTOR.DATE_PICKER.END_DATE' | translate
        }}"
        (dateChange)="onCustomEndChange(null, $event.value)"
        [defaultValue]="compareDateRange.end | date: 'mediumDate'"
        [min]="compareDateRange.start"
        [max]="maxEndCompareDate"
      />
      <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
      <mat-datepicker #end></mat-datepicker>
    </mat-form-field>
    <div
      class="date-range-selector-compare"
      *ngIf="compareDateRange$ | async as compareDate"
    >
      <mat-form-field>
        <input
          matInput
          placeholder="{{
            'FRONTEND.DATE_RANGE_SELECTOR.COMPARE_TO' | translate
          }}"
          [defaultValue]="compareDate"
          readonly
        />
      </mat-form-field>
    </div>
    <div>{{ 'FRONTEND.DATE_RANGE_SELECTOR.PERIOD' | translate }}</div>
    <mat-radio-group
      class="compare-date-range-radio-group"
      [(ngModel)]="selected"
    >
      <mat-radio-button
        *ngFor="let option of filterOptions"
        [value]="option.key"
        (change)="updateDateRangeData(option.key)"
      >
        {{ option.i18nKey | translate }}
      </mat-radio-button>
      <mat-radio-button
        [value]="seasonOptions[0].key"
        (change)="updateSeasonDate(seasonOptions[0].key)"
      >
        {{ seasonOptions[0].i18nKey | translate }}
      </mat-radio-button>
      <div
        *ngIf="this.seasonDatePickerType === 'Month'"
        class="dateRange-select"
      >
        <mat-form-field class="dateRange-select-cell">
          <mat-select
            (selectionChange)="onMonthSelectChanged($event.value, null)"
            [value]="currentMonth | date: 'LLLL'"
          >
            <mat-option
              *ngFor="let option of monthList"
              [value]="option | date: 'LLLL'"
            >
              {{ option | date: 'LLLL' }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="dateRange-select-cell">
          <mat-select
            (selectionChange)="onMonthSelectChanged(null, $event.value)"
            [value]="currentYear"
          >
            <mat-option *ngFor="let option of yearList" [value]="option">
              {{ option }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <mat-radio-button
        [value]="seasonOptions[1].key"
        (change)="updateSeasonDate(seasonOptions[1].key)"
      >
        {{ seasonOptions[1].i18nKey | translate }}
      </mat-radio-button>
      <div
        *ngIf="this.seasonDatePickerType === 'Quarter'"
        class="dateRange-select"
      >
        <mat-form-field class="dateRange-select-cell">
          <mat-select
            (selectionChange)="onQuarterSelectChanged($event.value, null)"
            [value]="currentQuarter"
          >
            <mat-option
              *ngFor="let option of quarters"
              [value]="option.section"
            >
              {{ option.i18nKey | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="dateRange-select-cell">
          <mat-select
            (selectionChange)="onQuarterSelectChanged(null, $event.value)"
            [value]="currentYear"
          >
            <mat-option *ngFor="let option of yearList" [value]="option">
              {{ option }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-radio-group>
  </mat-dialog-content>
</ng-container>

<ng-template #normalDatePicker>
  <mat-dialog-content class="date-filter-group">
    <mat-radio-group class="date-filter-radio-group" [(ngModel)]="selected">
      <mat-radio-button
        *ngFor="let option of filterOptions"
        [value]="option.key"
      >
        {{ option.i18nKey | translate }}
      </mat-radio-button>
    </mat-radio-group>

    <div class="custom-date-range">
      <mat-form-field class="picker-start">
        <input
          matInput
          [matDatepicker]="start"
          placeholder="{{
            'FRONTEND.DATE_RANGE_SELECTOR.DATE_PICKER.START_DATE' | translate
          }}"
          (dateChange)="onCustomStartChange($event.value)"
          [value]="customDate.start"
          [max]="customDate.end"
        />
        <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
        <mat-datepicker #start></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <input
          [matDatepicker]="end"
          matInput
          placeholder="{{
            'FRONTEND.DATE_RANGE_SELECTOR.DATE_PICKER.END_DATE' | translate
          }}"
          (dateChange)="onCustomEndChange($event.value)"
          [value]="customDate.end"
          [min]="customDate.start"
          [max]="maxEndDate"
        />
        <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
        <mat-datepicker #end></mat-datepicker>
      </mat-form-field>
    </div>
  </mat-dialog-content>
</ng-template>

<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>
    {{ 'FRONTEND.DATE_RANGE_SELECTOR.COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button class="" mat-flat-button color="primary" (click)="submit()">
    {{ 'FRONTEND.DATE_RANGE_SELECTOR.COMMON.ACTION_LABELS.APPLY' | translate }}
  </button>
</mat-dialog-actions>
